import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=bbb3a466&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=bbb3a466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb3a466",
  null
  
)

export default component.exports